import React from 'react';
import Navbar from 'components/landing/Navbar';
import HeroSection from 'components/landing/HeroSection';
import ValueProposition from 'components/landing/ValueProposition';
import UserPersonas from 'components/landing/UserPersonas';
import ConnectorsCarousel from 'components/landing/ConnectorsCarousel';
import DataFusionSection from 'components/landing/DataFusionSection';
import FeaturesSection from 'components/landing/FeaturesSection';
import HowItWorksSection from 'components/landing/HowItWorkSection';
import CTASection from 'components/landing/CTASection';
import Footer from 'components/landing/Footer';

export default function Home() {
  return (
    <div className="nb-landing min-h-screen bg-[#f5f5f0]">
      <Navbar />
      <main>
        <HeroSection />
        <div id="value">
          <ValueProposition />
        </div>
        <div id="personas">
          <UserPersonas />
        </div>
        <ConnectorsCarousel />
        <div id="data-fusion">
          <DataFusionSection />
        </div>
        <div id="features">
          <FeaturesSection />
        </div>
        <div id="how-it-works">
          <HowItWorksSection />
        </div>
        <div id="cta">
          <CTASection />
        </div>
      </main>
      <Footer />
    </div>
  );
}
